import { render, staticRenderFns } from "./resource-batch-review-record-dialog.vue?vue&type=template&id=6247315e&scoped=true"
import script from "./resource-batch-review-record-dialog.vue?vue&type=script&lang=js"
export * from "./resource-batch-review-record-dialog.vue?vue&type=script&lang=js"
import style0 from "./resource-batch-review-record-dialog.vue?vue&type=style&index=0&id=6247315e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6247315e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6247315e')) {
      api.createRecord('6247315e', component.options)
    } else {
      api.reload('6247315e', component.options)
    }
    module.hot.accept("./resource-batch-review-record-dialog.vue?vue&type=template&id=6247315e&scoped=true", function () {
      api.rerender('6247315e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/resource-batch-review-record-dialog.vue"
export default component.exports